import i18n from '@/i18n'

const KNOWN_API_ERROR_KEYS = new Set([
  'error_create_order_too_frequent',
  'error_ip_daily_order_limit_exceeded',
])

/**
 * Extract a user-visible message from eSIM API JSON bodies.
 *
 * Supported shapes:
 * - fail_message: { status: "1", message: "..." }
 * - fail: { status: "1", data: { error: "..." } }
 * - admin/cobo fail: { status: "1", error: "..." }
 */
export function getApiResponseMessage(body, fallback = '') {
  if (!body || typeof body !== 'object') {
    return fallback
  }

  if (typeof body.message === 'string' && body.message.trim()) {
    return body.message.trim()
  }

  const nested = body.data
  if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
    if (typeof nested.error === 'string' && nested.error.trim()) {
      return nested.error.trim()
    }
    if (typeof nested.message === 'string' && nested.message.trim()) {
      return nested.message.trim()
    }
  }

  if (typeof body.error === 'string' && body.error.trim()) {
    return body.error.trim()
  }

  return fallback
}

function translateKnownApiErrorKey(raw) {
  if (!KNOWN_API_ERROR_KEYS.has(raw)) {
    return raw
  }

  const { t, te } = i18n.global
  if (typeof te === 'function' && te(raw)) {
    return t(raw)
  }

  return raw
}

/**
 * Resolve API errors for display, with frontend i18n fallback for known keys.
 */
export function resolveApiErrorMessage(body, fallback = '') {
  const raw = getApiResponseMessage(body)
  if (!raw) {
    return fallback
  }

  return translateKnownApiErrorKey(raw) || fallback
}
